/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ResultDataStatisticsDto } from '../model/resultDataStatisticsDto';
import { StatisticsConfig } from '../model/statisticsConfig';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EngineStatisticsService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Supprime le cache des scripts Groovy
     * Utilisé les instances des scripts. A utiliser lors des modifications de scripts.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clearCacheUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public clearCacheUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public clearCacheUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public clearCacheUsingDELETE(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/statistics/cache/script`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer toutes les configurations
     * Cette requête récupérère toutes les configurations disponible pour un tenant et suivant les droits de l&#39;utilisateurs.
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllConfigUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<StatisticsConfig>>;
    public getAllConfigUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StatisticsConfig>>>;
    public getAllConfigUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StatisticsConfig>>>;
    public getAllConfigUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllConfigUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<StatisticsConfig>>(`${this.basePath}/api/statistics/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer les données
     * Cette requête récupérère toutes les données pour cette statistique disponible pour un tenant, partner et ces filtres.
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param endDate endDate
     * @param partners partners
     * @param startDate startDate
     * @param valuesFilters valuesFilters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataUsingPOST(xDataStoreID: string, code: string, endDate?: string, partners?: Array<string>, startDate?: string, valuesFilters?: any, observe?: 'body', reportProgress?: boolean): Observable<ResultDataStatisticsDto>;
    public getDataUsingPOST(xDataStoreID: string, code: string, endDate?: string, partners?: Array<string>, startDate?: string, valuesFilters?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResultDataStatisticsDto>>;
    public getDataUsingPOST(xDataStoreID: string, code: string, endDate?: string, partners?: Array<string>, startDate?: string, valuesFilters?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResultDataStatisticsDto>>;
    public getDataUsingPOST(xDataStoreID: string, code: string, endDate?: string, partners?: Array<string>, startDate?: string, valuesFilters?: any, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getDataUsingPOST.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getDataUsingPOST.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (partners) {
            partners.forEach((element) => {
                queryParameters = queryParameters.append('partners', <any>element);
            })
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResultDataStatisticsDto>(`${this.basePath}/api/statistics/getData`,
            valuesFilters,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mise à jour du cache
     * Cette requête mets à jours les données de statitiques dans mongo pour être récupéré en cache. Si le tenant n&#39;est pas indiqué alors la mise à jour est gobale.
     * @param code code
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDataWithDefaultValueUsingPUT(code: string, xDataStoreID?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateDataWithDefaultValueUsingPUT(code: string, xDataStoreID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateDataWithDefaultValueUsingPUT(code: string, xDataStoreID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateDataWithDefaultValueUsingPUT(code: string, xDataStoreID?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling updateDataWithDefaultValueUsingPUT.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/statistics/update/cache`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mise à jour des données dans l&#39;historique
     * Cette requête mets à jours l&#39;historisation des données. Si le tenant n&#39;est pas indiqué alors la mise à jour est gobale.
     * @param code code
     * @param endDate endDate
     * @param startDate startDate
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDataWithDefaultValueUsingPUT1(code: string, endDate: string, startDate: string, xDataStoreID?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateDataWithDefaultValueUsingPUT1(code: string, endDate: string, startDate: string, xDataStoreID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateDataWithDefaultValueUsingPUT1(code: string, endDate: string, startDate: string, xDataStoreID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateDataWithDefaultValueUsingPUT1(code: string, endDate: string, startDate: string, xDataStoreID?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling updateDataWithDefaultValueUsingPUT1.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling updateDataWithDefaultValueUsingPUT1.');
        }

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling updateDataWithDefaultValueUsingPUT1.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/statistics/update/history`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
